import { IconWithTransform, StackedIcon } from '@/fontawesome';

// This file sets what icon is used for each feature. Point is to not repeat fa-flag-ceckered every time we want to load races
export const featureIcons = {
    BIBS: 'fa-file-vector',
    CATEGORY: 'fa-layer-group',
    COMMUNICATION: 'fa-envelope-circle-check',
    CONTESTANT: 'fa-users',
    PRODUCTION: 'fa-display',
    DELETE: 'fa-trash-xmark',
    DEVICE: 'fa-tachograph-digital',
    DEVICESTATUS: 'fa-globe',
    EVENTGRAPHICS: 'fa-palette',
    ERROR: 'fa-circle-exclamation',
    EVENTS: 'fa-pen-to-square',
    FEDERATION: 'fa-circle-star',
    FILEARCHIVE: 'fa-files',
    GROUPS: 'fa-people-group',
    IDTYPES: 'fa-id-badge',
    INFO: 'fa-circle-info',
    MATRIX: 'fa-table',
    UNKNOWNTAGS: new StackedIcon('fa-tag', [{ iconName: 'fa-question', transform: new IconWithTransform({ shrink: 6, right: 8, up: 6 }) }]),
    POINTTYPES: 'fa-cubes',
    TRAININGLANES: 'fa-crosshairs-simple',
    QUESTION: 'fa-circle-question',
    RACES: 'fa-flag-checkered',
    READINGS: 'fa-wave-pulse',
    RELAY: 'fa-users-between-lines',
    SERIES: 'fa-list-ol',
    SETTINGS: 'fa-gear',
    STATIONS: 'fa-puzzle-piece',
    STATIONROLES: 'fa-puzzle-piece-alt',
    SUCCESS: 'fa-circle-check',
    TIP: 'fa-lightbulb-on',
    TRACKING: 'fa-map-location-dot',
    TRACKINGDEVICE: 'fa-satellite',
    USERS: 'fa-users',
    WARNING: 'fa-triangle-exclamation',
    RACESETUP: 'fa-puzzle',
    SPRINT: new StackedIcon('fa-sitemap', [], 90),
    REGION: 'fa-globe-pointer',
    LICENSES: 'fa-id-card',
};
